import React from 'react';
import { MdNotifications } from 'react-icons/md';
import { useContaNotifiche } from '../../ppp/hooks/useNotifiche';
import { useNotificheOperatoreApi } from '../services/notificheApi';

export default function NotificheOperatoreBadgeIcon() {
  const api = useNotificheOperatoreApi();
  const { count } = useContaNotifiche(api);

  return (
    <span className="relative inline-flex">
      <MdNotifications />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-red-500 text-white text-[8px] font-bold leading-none">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </span>
  );
}
